<h2 mat-dialog-title id="bekreftelses-dialog-tittel">{{ parametre.tittel }}</h2>
<mat-dialog-content>
  <p>{{ parametre.innhold }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  @if(!parametre.droppAvbrytKnapp){
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial class="avbryt">{{ parametre.avbrytKnapp }}</button>
  }
  @if(parametre.dialogStil == 'fare'){
    <button mat-raised-button color="warn" [mat-dialog-close]="true" class="ok">{{ parametre.okKnapp }}</button>
  } @else {
    <button mat-button [mat-dialog-close]="true" class="ok">{{ parametre.okKnapp }}</button>
  }
</mat-dialog-actions>
